import { Type } from 'class-transformer';
import { ARCreditApplicationSourceTransactionResultDto } from './ar-credit-application-source-transaction-result-dto';
import { ARCreditApplicationTargetTransactionResultDto } from './ar-credit-application-target-transaction-result-dto';

export class ARCreditApplicationEditorResultDto {
    @Type(() => ARCreditApplicationSourceTransactionResultDto)
    source: ARCreditApplicationSourceTransactionResultDto;
    @Type(() => ARCreditApplicationTargetTransactionResultDto)
    targets: ARCreditApplicationTargetTransactionResultDto[];
    @Type(() => Date)
    closedBookPeriod: Date;
    @Type(() => Date)
    minApplyDate: Date;
    @Type(() => Date)
    maxApplyDate: Date;
}
